/**
 * Datalab 系统内部 白名单
 */
import { getLocaleState } from '@home/utils/state';
import { ENV } from '@home/_config/config';
import { ChartType, TChartType } from '@dbl/core/chart';
import { ChartCalculateMode } from '@dbl/core/chartEditor';

/** User Filter */
// 是否 展示 user filter 相关交互的 白名单
export const USER_FILTER_GAME_CODES_MAP = {
  dev: ['databrain'], // 本地环境
  test: ['databrain'], // 线上dev环境 ENV也是test
  pre: ['i_game', 'datalab_demo'],
  pro: ['i_game', 'datalab_demo'],
};

// 判断游戏业务是否允许 User Filter 展示的方法
export const allowShowUserFilter = (gameCode: string) => {
  const allowList = USER_FILTER_GAME_CODES_MAP[ENV];
  if (!allowList) return false;

  const datalabReportInfo = getLocaleState('datalabReportInfo'); // 获取承接页面信息

  if (datalabReportInfo) {
    // 有值说明当前是iframe承接页面, 获取承接页面的gameCode
    return allowList.includes(datalabReportInfo.uid);
  }
  // datalab系统内部 或 非iframe承接页面
  return allowList.includes(gameCode);
};

// 判断图表类型是否可以展示 User Filter
export const allowChartTypeShowUserFilter = ({
  chartType,
  mode,
}: {
  chartType: string;
  mode?: string;
}) => {
  if (chartType === ChartType.Table) {
    // 表格类型只有聚合模式可以展示 User Filter
    return mode === ChartCalculateMode.Aggregate;
  }
  return [ChartType.Line, ChartType.Bar, ChartType.BigNumber].includes(
    chartType as TChartType,
  );
};
